var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 4.84971V7.14138C17.5 8.06221 16.7542 8.80804 15.8333 8.80804H4.16667C3.24583 8.80804 2.5 8.06221 2.5 7.14138V4.84971C2.5 3.92888 3.24583 3.18304 4.16667 3.18304H15.8333C16.7542 3.18304 17.5 3.92888 17.5 4.84971Z",
    stroke: "#3A57E8",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 14.2247V16.5164C17.5 17.4372 16.7542 18.183 15.8333 18.183H4.16667C3.24583 18.183 2.5 17.4372 2.5 16.5164V14.2247C2.5 13.3039 3.24583 12.558 4.16667 12.558H15.8333C16.7542 12.558 17.5 13.3039 17.5 14.2247Z",
    stroke: "#3A57E8",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInline);
export default __webpack_public_path__ + "static/media/inline.9934ca05b2b719b448bba46dac8c3615.svg";
export { ForwardRef as ReactComponent };